import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface ConfirmDialogData {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
}

@Component({
    selector: "valumize-fund-ai-setup-confirm-dialog",
    template: `
        <div class="dialog-header">
            <h2 mat-dialog-title>{{ data.title }}</h2>
            <button mat-icon-button type="button" class="dialog-close" aria-label="Close" data-test="dialog-close" (click)="dialogRef.close(false)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content>
            <p>{{ data.message }}</p>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-flat-button color="primary" type="button" (click)="dialogRef.close(true)">
                {{ data.confirmLabel ?? "Confirm" }}
            </button>
        </mat-dialog-actions>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmDialogComponent {
    readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
    readonly dialogRef = inject<MatDialogRef<ConfirmDialogComponent, boolean>>(MatDialogRef);
}
